import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnalyticsConsentComponent } from '@imagise/features/analytics-consent';
import { FooterComponent, HeaderComponent } from '@imagise/widgets';
import { BidiModule } from '@angular/cdk/bidi';
import { AppAnalyticsService } from '@imagise/features/analytics-consent';
import { AuthControlsComponent } from './auth/auth-controls.component';
import { ErrorReportingService } from '@imagise/features';

@Component({
  imports: [
    RouterModule,
    HeaderComponent,
    FooterComponent,
    BidiModule,
    AnalyticsConsentComponent,
    AuthControlsComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly analytics = inject(AppAnalyticsService);
  protected readonly errorReporting = inject(ErrorReportingService);
}
